<ng-container *ngIf="userService.user | async as user">
  <div
    class="question"
    [style.width.px]="700"
    *ngIf="state.accessState === AccessState.CanAccess; else noAccessTemplate"
  >
    <app-question-view
      *ngIf="state.question"
      [hideCommentCreator]="true"
      [hideComments]="true"
      [fromPractice]="false"
      [fromSession]="true"
      [pageType]="state.questionType"
      [question]="state.question"
      [courseId]="state.courseId"
      [sessionId]="''"
      [showExtras]="false"
      [user]="user.user"
      [state]="state"
      [static]="static"
      [expanded]="state.showAnswer"
      [showHint]="state.showHint"
      (answered)="answerQuestion($event)"
      (contentSizeChanged)="contentSizeChanged.emit($event)"
    ></app-question-view>
  </div>
</ng-container>

<ng-template #noAccessTemplate>
  <div [style.width.px]="700" [style.height.px]="700" class="cant-access">
    <div class="cant-access-content">
      <div class="circle">
        <svg-icon [height]="'72'" [width]="'72'" [icon]="'cant-access'"></svg-icon>
      </div>
      <div style="margin-top: 18px">
        <div class="question-access" *ngIf="state.accessState === AccessState.NotInQuestion">
          <p>{{ 'You do not have access to this question' | translate }}</p>
          <div style="margin-top: 37px" *ngIf="false">
            <button mat-flat-button class="btn-request d-sm-inline-block d-none" color="primary">
              <em class="material-icons">mail_outline</em>
              <span>{{ 'Request access' | translate }}</span>
            </button>
          </div>
        </div>
        <div *ngIf="state.accessState === AccessState.NotInCourse">
          <p style="width: 422px; font-size: 24px; line-height: 30px">
            {{
              'You do not have access to this question because you are not in the course.'
                | translate
            }}
          </p>
          <p style="width: 310px; line-height: 20px; font-size: 16px; margin-left: 56px">
            {{ 'Please ask the course admin to grant you access' | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</ng-template>
